// Recovered compiled webpack factory 60567. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { $N: () => i, Hd: () => o, xE: () => s });
  var n = r(16649);
  let a = r(49636).O;
  function o(e, t = {}) {
    if (!e) return "<unknown>";
    try {
      let r,
        o = e,
        i = [],
        s = 0,
        l = 0,
        u = Array.isArray(t) ? t : t.keyAttrs,
        c = (!Array.isArray(t) && t.maxStringLength) || 80;
      for (
        ;
        o &&
        s++ < 5 &&
        ((r = (function (e, t) {
          let r = [];
          if (!e?.tagName) return "";
          if (a.HTMLElement && e instanceof HTMLElement && e.dataset) {
            if (e.dataset.sentryComponent) return e.dataset.sentryComponent;
            if (e.dataset.sentryElement) return e.dataset.sentryElement;
          }
          r.push(e.tagName.toLowerCase());
          let o = t?.length
            ? t.filter((t) => e.getAttribute(t)).map((t) => [t, e.getAttribute(t)])
            : null;
          if (o?.length)
            o.forEach((e) => {
              r.push(`[${e[0]}="${e[1]}"]`);
            });
          else {
            e.id && r.push(`#${e.id}`);
            let t = e.className;
            if (t && (0, n.Kg)(t)) for (let e of t.split(/\s+/)) r.push(`.${e}`);
          }
          for (let t of ["aria-label", "type", "name", "title", "alt"]) {
            let n = e.getAttribute(t);
            n && r.push(`[${t}="${n}"]`);
          }
          return r.join("");
        })(o, u)),
        "html" !== r && (!(s > 1) || !(l + 3 * i.length + r.length >= c)));

      )
        (i.push(r), (l += r.length), (o = o.parentNode));
      return i.reverse().join(" > ");
    } catch {
      return "<unknown>";
    }
  }
  function i() {
    try {
      return a.document.location.href;
    } catch {
      return "";
    }
  }
  function s(e) {
    if (!a.HTMLElement) return null;
    let t = e;
    for (let e = 0; e < 5 && t; e++) {
      if (t instanceof HTMLElement) {
        if (t.dataset.sentryComponent) return t.dataset.sentryComponent;
        if (t.dataset.sentryElement) return t.dataset.sentryElement;
      }
      t = t.parentNode;
    }
    return null;
  }
}
